import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import {
  AccountService,
  AlertService,
  CampaignProductService,
  CampaignService,
  CampaignTrackingService,
  CRMCampaignService,
  FunnelStepService,
  MerchantService,
  ReportsConfigService,
  ReportsService,
  StorageService,
  UserService,
  CancelReasonCategoryService
} from "../_services";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgxSmartModalService } from "ngx-smart-modal";
import { ReportsAbstractV2Component } from "./reports-abstract-v2.component";
import { MultiOptions } from "../custom-multi-select/multi-select";
import { TrafficSourceFields, TrafficSourceFilters } from "./utils/constants";
import { cloneDeep } from "lodash";
import { ReportTypes } from "./models/reports";

@Component({
  moduleId: module.id.toString(),
  selector: 'traffic-source-report',
  templateUrl: './templates/mini-report.component.html',
  styleUrls: ['./styles/reports-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TrafficSourceReportComponent extends ReportsAbstractV2Component implements OnInit, AfterViewInit {
  reportTitle = 'Traffic Source Report';
  fields: MultiOptions = cloneDeep(TrafficSourceFields);
  filters: MultiOptions = cloneDeep(TrafficSourceFilters);
  reportType = ReportTypes.TRAFFIC_SOURCE;
  showSummaryRow = true;
  enableDetailedDownload: boolean = true;
  dropdownsLoading: boolean = false;

  predefinedFields = [
    'exclude_hangups',
    'exclude_unknowns',
    'exclude_child_sessions',
    'exclude_child_orders',
    'exclude_tests',
  ];
  commonReportsFields = [];
  summaryFields = [];

  selectedDimensions = [
    {
      model: 'source',
      label: 'Path channel',
      selected: true,
      disabled: false,
    },
    {
      model: 'sid1',
      label: 'Source sub 1',
      selected: true,
      disabled: false,
    },
    {
      model: 'sid2',
      label: 'Source sub 2',
      selected: true,
      disabled: false,
    },
    {
      model: 'tracking_source',
      label: 'Path channel source',
      selected: true,
      disabled: false,
    },
    {
      model: 'session_count',
      label: 'Session Quantity',
      selected: true,
      disabled: false,
    },
  ];

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected alertService: AlertService,
    public reportsService: ReportsService,
    protected campaignService: CampaignService,
    protected reportsConfigService: ReportsConfigService,
    protected trackingSourceService: CampaignTrackingService,
    protected userService: UserService,
    protected accountService: AccountService,
    protected campaignProductService: CampaignProductService,
    protected crmCampaignService: CRMCampaignService,
    protected storageService: StorageService,
    protected stepService: FunnelStepService,
    protected merchantService: MerchantService,
    protected modalService: NgxSmartModalService,
    protected cancelReasonCategoryService: CancelReasonCategoryService
  ) {
    super(
      router,
      location,
      route,
      alertService,
      reportsService,
      campaignService,
      reportsConfigService,
      trackingSourceService,
      userService,
      accountService,
      campaignProductService,
      crmCampaignService,
      storageService,
      stepService,
      merchantService,
      modalService,
      cancelReasonCategoryService
    );

    this.updatePreSelectedDimensions(['source', 'sid1', 'sid2', 'tracking_source', 'session_count']);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {}

  // Override getSummary to do nothing since this report has no summary
  getSummary() {
    this.isSummaryLoading = false;
  }

  // Override getReport to skip summary fetching
  getReport(fetchSummary: boolean = false) {
    super.getReport(false);
  }
}
